// The Mr•Wigglez brand signature — hot-pink wordmark with a toxic-lime neon dot.
export const WigglezMark = ({ className = "", size = "text-xs" }) => (
  <span
    className={`font-display font-black tracking-tight inline-flex items-end leading-none ${size} ${className}`}
    data-testid="wigglez-mark"
    aria-label="Mr. Wigglez"
  >
    <span style={{ color: "#ff1493", textShadow: "0 0 6px rgba(255,20,147,0.75)" }}>Mr</span>
    <span
      className="inline-block rounded-full mx-[2px] mb-[0.14em]"
      style={{ width: "0.32em", height: "0.32em", background: "#ccff00", boxShadow: "0 0 7px #ccff00, 0 0 14px rgba(204,255,0,0.6)" }}
    />
    <span style={{ color: "#ff1493", textShadow: "0 0 6px rgba(255,20,147,0.75)" }}>Wigglez</span>
  </span>
);

export default WigglezMark;
